import { useEffect } from 'react'

export function useHistoryListener(onPopState: VoidFunction) {
    useEffect(() => {
        const abortController = new AbortController()

        window.addEventListener(
            'popstate',
            (e) => {
                e.preventDefault()
                onPopState()
            },
            { signal: abortController.signal }
        )

        return () => abortController.abort()
    }, [])
}
